const apps = [
    {
        id: "firefox",
        title: "Firefox Browser",
        icon: './themes/Yaru/apps/firefox.svg',
        disabled: false,
        favourite: true,
        desktop_shortcut: true,
        meta: {}
    },
    {
        id: "todo-ist",
        title: "Todoist",
        icon: './themes/Yaru/apps/todoist.png',
        disabled: false,
        favourite: true,
        desktop_shortcut: false,
        meta: {}
    },
    {
        id: "about-obj9527",
        title: "About Obj9527",
        icon: './themes/Yaru/system/user-home.png',
        disabled: false,
        favourite: true,
        desktop_shortcut: true,
        meta: {}
    },
    {
        id: "vscode",
        title: "Visual Studio Code",
        icon: './themes/Yaru/apps/vscode.png',
        disabled: false,
        favourite: true,
        desktop_shortcut: false,
        meta: {}
    },
    {
        id: "terminal",
        title: "Terminal",
        icon: './themes/Yaru/apps/bash.png',
        disabled: false,
        favourite: true,
        desktop_shortcut: false,
        meta: {}
    },
    {
        id: "music",
        title: "Music",
        icon: './themes/Yaru/apps/vue-aplayer-round.png',
        disabled: false,
        favourite: true,
        desktop_shortcut: false,
        meta: {}
    },
    {
        id: "settings",
        title: "Settings",
        icon: './themes/Yaru/apps/gnome-control-center.png',
        disabled: false,
        favourite: true,
        desktop_shortcut: false,
        meta: {}
    },
    {
        id: "trash",
        title: "Trash",
        icon: './themes/Yaru/system/user-trash-full.png',
        disabled: false,
        favourite: true,
        desktop_shortcut: false,
        meta: {}
    },
    {
        id: "gedit",
        title: "Send a Message",
        icon: './themes/Yaru/apps/gedit.png',
        disabled: false,
        favourite: false,
        desktop_shortcut: true,
        meta: {}
    },
]
export default apps
